<template>
  <el-dialog
    :title="`${record.o_id ? '' : 'New '}Attendance Record`"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    @close="close"
  >
    <el-form v-if="record">
      <el-form-item label="User">
        <el-select
          v-model="record.user_id"
          filterable
          remote
          reserve-keyword
          placeholder="Search Name"
          :remote-method="remoteMethod"
          :loading="usersLoading"
        >
          <el-option
            v-for="item in searchList"
            :key="item.o_id"
            :label="getFullName(item)"
            :value="item.o_id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Status">
        <el-select
          v-model="record.attendance_type"
          size="small"
          value-key="o_id"
          placeholder="Type"
        >
          <el-option
            v-for="att in attendanceTypes"
            :key="att.o_id"
            :label="att.name"
            :value="att.o_id"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">Cancel</el-button>
      <el-button type="primary" @click="save">Save</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
    props: {
        attendanceTypes: {required: true},
        eventId: {required: true}
    },
    data() {
        return {
            dialogVisible: false,
            usersLoading: false,
            record: {
                user_id: null,
                attendance_type: 4,
                event_id: this.eventId
            },
            searchList: []
        };
    },
    methods: {
        remoteMethod(query) {
            if (query !== "") {
                this.usersLoading = true;
                setTimeout(() => {
                    this.axios
                        .get("/api/v1/search", {
                            params: {query: query},
                            headers: {"Content-Type": "application/json"},
                            credentials: "same-origin"
                        })
                        .then((response) => {
                            this.searchList = response.data.users;
                            this.usersLoading = false;
                        })
                        .catch((err) => {
                            this.usersLoading = false;
                            console.error(err);
                            this.$message({
                                showClose: true,
                                message: err.response.data.errors.title,
                                type: "error"
                            });
                        });
                }, 200);
            } else {
                this.searchList = [];
            }
        },
        open() {
            this.$emit("open");
            this.record = {
                user_id: null,
                attendance_type: 4,
                event_id: this.eventId
            };
            this.dialogVisible = true;
        },
        close() {
            this.$emit("close");
            this.record = {
                user_id: null,
                attendance_type: 4,
                event_id: this.eventId
            };
            this.dialogVisible = false;
        },
        save() {
            var route;
            if (this.record.o_id) {
                route = `/api/v1/attendance/${this.record.o_id}`;
                this.axios
                    .put(route, this.record, {
                        headers: {"Content-Type": "application/json"},
                        credentials: "same-origin"
                    })
                    .then((response) => {
                        this.$emit("save", response.data);
                        this.close();
                        this.$message({
                            showClose: true,
                            message: "Attendance record saved successfuly.",
                            type: "success"
                        });
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message({
                            showClose: true,
                            message: err.response.data.errors.title,
                            type: "error"
                        });
                    });
            } else {
                route = "/api/v1/attendance";
                this.axios
                    .post(route, this.record, {
                        headers: {"Content-Type": "application/json"},
                        credentials: "same-origin"
                    })
                    .then((response) => {
                        this.$emit("save", response.data);
                        this.close();
                        this.$message({
                            showClose: true,
                            message: "Attendance record created successfuly",
                            type: "success"
                        });
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message({
                            showClose: true,
                            message: err.response.data.errors.title,
                            type: "error"
                        });
                    });
            }
        }
    }
};
</script>
